import React from "react";
import styles from "../User/Auth.module.css";

const faqs = [
  {
    q: "How do I get my affiliate code?",
    a: "Register on the affiliate page. Your code will be shown on your dashboard after approval."
  },
  {
    q: "How do I earn commission?",
    a: "Share your affiliate link/code. When a guest books using your link/code, you earn 5% commission."
  },
  {
    q: "How long does the cookie last?",
    a: "Affiliate cookies last for 30 days."
  },
  {
    q: "How and when do I get paid?",
    a: "Commissions are paid weekly or monthly via bank transfer once you reach ₦10,000."
  },
  {
    q: "Can I collect payment from guests?",
    a: "No. All payments must go directly to Aurelia Apartments."
  }
];

const AffiliateSupport = () => (
  <div className={styles.wrapper}>
    <div className={styles.box}>
      <h2 className={styles.heading}>Affiliate Support & FAQ</h2>
      <div className={styles.note}>
        <strong>Contact:</strong> affiliate@aurelia-apartments.com<br />
        <strong>Phone:</strong> +2348165028212<br />
        <strong>WhatsApp:</strong> +2349152304757
      </div>
      <h3 style={{marginTop:"2rem"}}>Frequently Asked Questions</h3>
      <div style={{marginTop:"1rem"}}>
        {faqs.map((faq, idx) => (
          <div key={idx} style={{marginBottom:"18px"}}>
            <div style={{fontWeight:"bold", marginBottom:"6px"}}>{faq.q}</div>
            <div style={{color:"#333"}}>{faq.a}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default AffiliateSupport;
